// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { ChangeEvent, useLayoutEffect, useRef, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import S from './styles';
import ImageIcon from '../assets/image_icon.svg';
import CrossIcon from '../assets/cross-image.svg';

interface ImageUpload {
  content: string;
  contentType: string;
  name: string;
  file: File;
}

interface Props extends React.ComponentPropsWithRef<any> {
  message: string;
  placeholder: string;
  isLoading: boolean;
  onChange?: React.ChangeEventHandler;
  onBlur?: React.FocusEventHandler;
  onSubmit?: React.FormEventHandler;
  listImagePreviewUrls: ImageUpload[];
  setListImagePreviewUrl: (value: React.SetStateAction<ImageUpload[]>) => void;
  disabled: boolean;
  inline?: boolean;
}

const ReplyField: React.FC<Props> = ({
  message,
  placeholder,
  isLoading,
  onChange,
  onBlur,
  onSubmit,
  listImagePreviewUrls,
  setListImagePreviewUrl,
  disabled,
  inline,
  ...props
}) => {
  const intl = useIntl();
  const [tooltipPos, setTooltipPos] = useState<{ left?: string; right?: string; top?: string }>();
  const [tooltipText, setTooltipText] = useState('');
  // type: button / imgDelete
  const [tooltipType, setTooltipType] = useState('');
  const inputFileRef = useRef<HTMLInputElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const errorText = props.errorText;
  const setErrorText = props.setErrorText;

  useLayoutEffect(() => {
    if (!textareaRef.current) return;
    textareaRef.current.style.height = 'auto';
    textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'
  }, [message, listImagePreviewUrls.length === 0]);

  const onImageBtnClick = () => {
    inputFileRef.current?.click();
  };

  const onDeleteBtnClick = (content: string) => {
    const newList = listImagePreviewUrls.filter(data => data.content !== content);
    setListImagePreviewUrl(newList)
    setTooltipPos(undefined);
    setErrorText('');
  };
  const imagePreview = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const acceptType = ['image/png', 'image/svg+xml', 'image/gif', 'image/jpeg', 'image/jpg'];
      if (listImagePreviewUrls.length < 5) {
        setErrorText('');
        if (acceptType.includes(file.type)) {
          const url = reader.result as string;
          setListImagePreviewUrl(data => [...data, { content: url, file, name: file.name, contentType: file.type }])
        }
      } else {
        setErrorText('I032');
      }
    };
  }
  const handleChangeImage = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      const files = e.target.files;
      console.log({ files })
      for (let i = 0; i < files.length; i++) {
        imagePreview(files[i])
      }
    }
  }

  const handleMouseEnter = (e: React.MouseEvent<HTMLImageElement, MouseEvent>, message: string, type: string, index?: number) => {
    const { x, y, width } = e.currentTarget.getBoundingClientRect();
    if (type === 'imgDelete') {
      const imgindex = index ? index : 0;
      setTooltipPos({ left: (7+ 6*imgindex) + 'vw' })
    } else {
      setTooltipPos({ right: '7vw' })
    }
    setTooltipType(type);
    setTooltipText(message);
  }
  const handleMouseLeave = () => {
    setTooltipPos(undefined);
  }

  const renderTextarea = () => {
    return (
      <S.Textarea
        disabled={isLoading}
        ref={textareaRef}
        name="message"
        value={message}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        rows={1} /* Prevent height = 2 * line-height bugs */
        maxLength={400}
        inline={inline}
      />
    )
  }

  const renderImageUploadWrapper = () => {
    if (listImagePreviewUrls.length === 0) {
      return;
    }
    return (
      <S.ImageUploadWrapper>
        {listImagePreviewUrls.map((data, index) => (
          <>
            <S.ImageContainer key={data.content}>
              <S.ImageUploadItem src={data.content} />
              <S.CrossIcon
                onClick={() => !isLoading && onDeleteBtnClick(data.content)}
                onMouseEnter={(e) => !isLoading && handleMouseEnter(e, intl.formatMessage({ id: 'I023' }), 'imgDelete', index)}
                onMouseLeave={() => !isLoading && handleMouseLeave()}
                src={CrossIcon}
              />
            </S.ImageContainer>
          </>
        ))}
        { tooltipType === 'imgDelete' ? renderTooltip() : null}
      </S.ImageUploadWrapper>
    )
  }

  const renderButtonWrapper = () => {
    return (
      <S.ButtonWrapper>
        <S.ImageWrapper>
          <S.ImageBtn
            onClick={(!isLoading) ? onImageBtnClick : undefined}
            onMouseEnter={(e) => !isLoading && handleMouseEnter(e, intl.formatMessage({ id: 'I014' }), 'button')}
            onMouseLeave={() => !isLoading && handleMouseLeave()}
            src={ImageIcon}
          />
        </S.ImageWrapper>
        { tooltipType === 'button' ? renderTooltip() : null}
        <S.TextCountWrapper>
          {message.length > 0 && <S.TextCount>{message.length}/400</S.TextCount>}
          <S.Btn type="submit" disabled={disabled} isLoading={isLoading} onClick={onSubmit}>
            {isLoading ? (<S.LoadingIcon size={5} />) : intl.formatMessage({ id: 'I012' })}
          </S.Btn>
        </S.TextCountWrapper>
      </S.ButtonWrapper>
    )
  }

  const renderTooltip = () => {
    if (!tooltipPos)
      return;

    return (
      <S.Tooltip style={tooltipPos}>
        {tooltipText}
      </S.Tooltip>
    )
  }

  if (inline) {
    return (
      <S.InlineWrapper {...props}>
        <S.InlineMessageWrapper>
          {renderTextarea()}
          {renderImageUploadWrapper()}
        </S.InlineMessageWrapper>
        {renderButtonWrapper()}
        <S.FileInput
          name="image"
          onChange={handleChangeImage}
          ref={inputFileRef}
        />
      </S.InlineWrapper>
    )
  }

  return (
    <S.MessageFieldWrapper {...props}>
      {renderTextarea()}
      <S.BottomWrapper>
        {renderImageUploadWrapper()}
        {renderButtonWrapper()}
      </S.BottomWrapper>
      <S.FileInput
        name="image"
        onChange={handleChangeImage}
        ref={inputFileRef}
      />
      { errorText ? <S.ErrorText><FormattedMessage id={errorText}/></S.ErrorText> : null}
    </S.MessageFieldWrapper>
  )
}

export { ReplyField as default };
